import React, { useEffect, useState } from "react";
import {
  Badge,
  Chip,
  CircleLoader,
  DynamicTab,
  NewTab,
  PageTab,
  PageTabAdv,
} from "../../../components";
import FormsList from "./List/FormsList";
import FontFamily from "./List/FontFamily";
import ModalItems from "./List/ModalItems";
import ButtonsList from "./List/ButtonsList";
import TagsItems from "./List/TagsItems";
import InfoItems from "./List/InfoItems";

import ToastItems from "./List/ToastItems";

import DropdownMenuList from "./List/DropdownMenuList";
import BadgeList from "./List/BadgeList";
import Accordion from "./List/Accordion";
import Loading from "./List/Loading";
import ChipList from "./List/ChipList";
import TabsList from "./List/TabsList";
import ChatList from "./List/ChatList";
import TableList from "./List/TableList";

import LoopList from "./List/LoopList";

////
import AddTableModal from "./List/TableModals/AddTableModal";
import { useLocation } from "react-router-dom";
import PageTabList from "./List/PageTabList";
import SearchList from "./List/SearchList";
import DailyProductionList from "./List/DailyProductionList";
import LoopFormFieldsList from "./List/LoopFormFieldsList";
import CalendarList from "./List/CalendarList";
import ListList from "./List/ListList";
import TimelineList from "./List/TimelineList";
import TooltipExamples from "./List/TooltipExamples";
import TitleList from "./List/TitleList";
import OtherList from "./List/OtherList";
import ChartsList from "./List/ChartsList";
import OnboardingList from "./List/OnboardingList";
import InvoiceList from "./List/InvoiceList";
import PdfGeneratorList from "./List/PdfGeneratorList";
import MultiLevelBuilderList from "./List/MultiLevelBuilderList";
import TabNextPrev from "./List/TabNextPrev";
import ChartsNewList from "./List/ChartsNewList";
import ChartsNewListAdv from "./List/ChartsNewListAdv";
import CollapsibleWrapperList from "./List/CollapsibleWrapperList";
import TableFull from "./List/TableFull";
import TreeHierarchyList from "./List/TreeHierarchyList";
import AudioPlayerList from "./List/AudioPlayerList";
import TabLoading from "./List/TabLoading";
import DailyProductionWidgetPage from "../../../components/DailyProduction/Dailyproductionwidgetpage";

const ComponentsList = () => {
  const location = useLocation();
  const fullHashPath = location.hash.slice(1).split("/");

  const [activeModal, setActiveModal] = useState(null);
  const [isTabLoading, setIsTabLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsTabLoading(false);
    }, 10000);
    return () => clearTimeout(timer);
  }, []);

  const handleOpenModal = (modalType) => {
    setActiveModal(modalType);
  };

  const handleCloseModal = () => {
    setActiveModal(null);
  };

  const ModalComponents = {
    tables: AddTableModal,
  };

  const renderActiveModal = () => {
    if (!activeModal) return null;

    const ModalComponent = ModalComponents[activeModal];
    return <ModalComponent isOpen={true} onClose={handleCloseModal} />;
  };

  const tabList = [
    {
      title: "AudioPlayer",
      page: <AudioPlayerList />,
      type: "main",
    },
    {
      title: "DailyProductionWidget",
      page: <DailyProductionWidgetPage />,
      type: "main",
    },
    {
      title: (
        <span className="flex items-center gap-2">
          <span>Tab Loading</span>
          {isTabLoading ? <CircleLoader /> : "12"}
        </span>
      ),
      disabled: isTabLoading,
      page: <TabLoading />,
      type: "main",
    },
    // {
    //   title: "TreeHierarchy",
    //   page: <TreeHierarchyList />,
    //   type: "main",
    // },
    {
      title: "Table Full",
      page: <TableFull />,
      type: "main",
    },
    {
      title: "Collapsible Wrapper",
      page: <CollapsibleWrapperList />,
      type: "main",
    },
    {
      title: "Charts New Adv",
      page: <ChartsNewListAdv />,
      type: "main",
    },
    {
      title: "Charts New",
      page: <ChartsNewList />,
      type: "main",
    },
    {
      title: "Info",
      page: <InfoItems />,
      type: "main",
    },
    {
      title: "Tabs Next Prev",
      page: <TabNextPrev />,
      type: "main",
    },
    {
      title: "Badge",
      page: <BadgeList />,
      type: "main",
    },
    {
      title: "PDF Generator",
      page: <PdfGeneratorList />,
      type: "main",
    },
    {
      title: "Loop",
      page: <LoopFormFieldsList />,
      type: "main",
    },
    {
      title: "Accordion",
      page: <Accordion />,
      type: "main",
    },

    {
      title: "Buttons",
      page: <ButtonsList />,
      type: "main",
    },
    {
      title: "Calendars",
      page: <CalendarList />,
      type: "main",
    },
    {
      title: "Chat",
      page: <ChatList />,
      type: "main",
    },
    {
      title: "Chip",
      page: <ChipList />,
      type: "main",
    },
    {
      title: "Dropdown Menu",
      page: <DropdownMenuList />,
      type: "main",
    },
    {
      title: "Forms",
      page: <FormsList />,
      type: "main",
    },
    {
      title: "Info",
      page: <InfoItems />,
      type: "main",
    },
    {
      title: "List",
      page: <ListList />,
      type: "main",
    },
    {
      title: "Loading",
      page: <Loading />,
      type: "main",
    },

    {
      title: "Modal",
      page: <ModalItems />,
      type: "main",
    },

    {
      title: "Table",
      page: <TableList />,
      type: "main",
      subTabs: [
        {
          title: "Add Table",
          icon: "add",
          action: () => handleOpenModal("tables"),
        },
      ],
    },
    {
      title: "Tabs",
      page: <TabsList />,
      type: "main",
    },
    {
      title: "Tags",
      page: <TagsItems />,
      type: "main",
    },
    {
      title: "Timeline",
      page: <TimelineList />,
      type: "main",
    },
    {
      title: "Title",
      page: <TitleList />,
      type: "main",
    },
    {
      title: "Toast",
      page: <ToastItems />,
      type: "main",
    },
    {
      title: "Tooltip",
      page: <TooltipExamples />,
      type: "main",
    },
    {
      title: "Charts",
      page: <ChartsList />,
      type: "main",
    },
    {
      title: "Onboarding",
      page: <OnboardingList />,
      type: "main",
    },
    {
      title: "Multi Level Builder List",
      page: <MultiLevelBuilderList />,
      type: "main",
    },
    {
      title: "Other",
      page: <OtherList />,
      type: "main",
    },
    // {
    //   title: "Tooltip",
    //   page: <TooltipExamples />,
    //   type: "main",
    // },

    // {
    //   title: "Loop Form Fields",
    //   page: <LoopFormFieldsList />,
    //   type: "main",
    // },
    // {
    //   title: "DailyProduction",
    //   page: <DailyProductionList />,
    //   type: "main",
    // },
    // {
    //   title: "Search",
    //   page: <SearchList />,
    //   type: "main",
    // },

    // {
    //   title: "Page Tab",
    //   page: <PageTabList />,
    //   type: "main",
    // },
    // {
    //   title: "Table",
    //   page: <TableList />,
    //   type: "main",
    //   subTabs: [
    //     {
    //       title: "Add Table",
    //       icon: "add",
    //       action: () => handleOpenModal("tables"),
    //     },
    //   ],
    // },

    // {
    //   title: "Loop List",
    //   page: <LoopList />,
    //   type: "main",
    // },

    // {
    //   title: "Tabs",
    //   page: <TabsList />,
    //   type: "main",
    // },

    // {
    //   title: "Font Family",
    //   page: <FontFamily />,
    //   type: "main",
    // },

    // {
    //   title: "Modal",
    //   page: <ModalItems />,
    //   type: "main",
    // },
    // {
    //   title: "Tags",
    //   page: <TagsItems />,
    //   type: "main",
    // },

    // {
    //   title: "Tooltip",
    //   page: <TooltipExamples />,
    //   type: "main",
    // },
    // {
    //   title: "Toast",
    //   page: <ToastItems />,
    //   type: "main",
    // },
    // {
    //   title: "Dropdown Menu",
    //   page: <DropdownMenuList />,
    //   type: "main",
    // },
    // {
    //   title: "Badge",
    //   page: <BadgeList />,
    //   type: "main",
    // },

    // {
    //   title: "Loading Subpage",
    //   page: <Loading />,
    //   type: "sub",
    // },
    // {
    //   title: "Add Employee",
    //   link: "/employee/add-employee",
    //   type: "sub",
    //   icon: "add",
    // },
  ];

  return (
    <div className="flex-1 flex overflow-hidden">
      <NewTab
        tabs={tabList}
        color="black"
        variant="outlined"
        //mainTabsShow={3}
        mode="url"
        tabId="components-list"
      />
      {renderActiveModal()}
    </div>
  );
};

export default ComponentsList;
